import { render, staticRenderFns } from "./NodeComments.vue?vue&type=template&id=b8da045c&scoped=true"
import script from "./NodeComments.vue?vue&type=script&lang=js"
export * from "./NodeComments.vue?vue&type=script&lang=js"
import style0 from "./NodeComments.vue?vue&type=style&index=0&id=b8da045c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8da045c",
  null
  
)

export default component.exports